import { api } from "./api";

export const busCreate = async (data) => {
  return await api.post("/bus/add", data);
};
export const busList = async (addUrl = "") => {
  let url = `/bus/list?${addUrl}`;
  return await api.get(url);
};

export const busUpdate = async (data) => {
  return await api.post("/bus/update", data);
};
export const busDelete = async (id) => {
  return await api.get(`/bus/delete/${id}`);
};
export const busStatusUpdate = async (data) => {
  return await api.post("/bus/status/update", data);
};

export const busRoute = async (url = "") => {
  return await api.get(`/bus/route/list?${url}`);
};

export const busRouteAdd = async (data) => {
  return await api.post("/bus/route/add", data);
};
export const busRouteUpdate = async (data) => {
  return await api.post("/bus/route/update", data);
};

export const busRouteDelete = async (id) => {
  return await api.get(`/bus/route/delete/${id}`);
};

export const busStudentsList = async (addUrl = "") => {
  let url = `/bus/students/list?${addUrl}`;
  return await api.get(url);
};


export const busStudentView = async (id) => {
  return await api.get(`/bus/students/view?id=${id}`);
};

export const busReport = async (addUrl = "") => {
  let url = `/bus/report?${addUrl}`;
  return await api.get(url);
};

export const studentBusData = async (url = "") => {
  return await api.get(`/student/bus/data?${url}`);
};

export const busStudentTransfer = async (data) => {
  return await api.post(
    `/student/bus/transfer`,
    data
  );
};